import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Language } from '../../services/language.service';
import { LectionaryItemType } from '../../services/lectionary-item-type.service';
import { ApiService } from '../../../../services/api.service';
import { Localized } from '../../../../objects';
import { ReligionBranchSummary, ReligionBranchServiceService } from '../../services/religion-branch.service';

@Component({
  selector: 'app-lectionary-item-type-edit',
  templateUrl: './lectionary-item-type-edit.component.html',
  styleUrls: ['./lectionary-item-type-edit.component.css']
})
export class LectionaryItemTypeEditComponent implements OnInit {

  public currentLanguageCode = "eng";
  public currentLanguage: Language;
  public currentLocalizedData: Localized;
  public item: LectionaryItemType;
  public listsLoaded = true;

  public lectionaryItemTypes: LectionaryItemType[];
  public religionBranches: ReligionBranchSummary[];

  constructor(
    private dialog: MatDialogRef<LectionaryItemTypeEditComponent>,
    private religionBranchSvc: ReligionBranchServiceService,
    private apiSvc: ApiService) { }


    ngOnInit() {

      this.listsLoaded = false;

      this.currentLocalizedData = null;
      if (this.item != null && this.item.Localized != null) {
        this.currentLocalizedData = this.item.Localized[0];
      }

      var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
        (data) => {
          this.religionBranches = data;
        }
      )

      Promise.all([religionBranchPromise]).then(
        (data) => {
          console.log("All promises are completed");
          this.listsLoaded = true;
        }
      )

    }

  public LoadItem(item: LectionaryItemType) {
    this.item = item;
    this.currentLocalizedData = this.item.Localized[0];
  }

  private CurrentLocalizedData(): Localized {

    if (this.currentLanguage == null) {return null;}

    var result = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });
    if (result.length === 1) {
     // console.log("LocalizedData Found", result[0]);
      return result[0];
    }

    return null;
  }

  private addLocalizationIfNeeded() {

    if (this.currentLanguage == null) { return; };
    if (this.item == null) { return ; }
    if (this.item.Localized == null) {
      this.initLocalization();
    }

    var localizedData = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });

    //console.log("addLocalizationIfNeeded", localizedData, this.currentLanguage.Code);

    if (localizedData.length === 0) {
      this.initLocalization();
    }

  }

  private initLocalization() {
    // console.log("adding new localization");
    if (this.item.Localized == null) {
      this.item.Localized = new Array<Localized>();
    }
     var newData = new Localized();
     newData.LanguageCode = this.currentLanguage.Code;
     this.item.Localized.push(newData);
  }

  public setSelectedLanguage(language: Language) {

    console.log("setSelectedLangage", language);
    this.currentLanguage = language;
    this.addLocalizationIfNeeded();

  }

  private setModelValue(value: any, target: any) {

    if (target == null) {
      target = {
        Id: value
      };
    } else {
      target.Id = value;
    }

    return target;

  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.apiSvc.post("api/lectionaryitemtype/save", this.item).subscribe(
      (data: LectionaryItemType) => {
        this.item = data;
        console.log(data);
        this.dialog.close(data);
      },
      (err) => {
        console.log("error", err);
      //  this.isLoading = false;
      }
    );

  }
}
